<micro-select-combo #sel
              placeholder="MNO"
              routerBase="mnos"
              [mode]="mode"
              [(id)]="mnoId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
              [blur]="onTouched"
>
</micro-select-combo>
